var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79036 5.16699H12.9168C16.4605 5.16699 19.3327 8.03923 19.3327 11.5829C19.3327 15.1266 16.4605 17.9999 12.9168 17.9999H8.82936C8.18513 17.9999 7.66341 17.4771 7.66341 16.8329C7.66341 16.1887 8.18513 15.667 8.82936 15.667H12.9168C15.1721 15.667 16.9998 13.8382 16.9998 11.5829C16.9998 9.32756 15.1721 7.49992 12.9168 7.49992H4.79036L7.42409 10.1337C7.90314 10.6116 7.90314 11.3882 7.42409 11.8662C6.94613 12.3441 6.17064 12.3441 5.69159 11.8662L1.02567 7.19911C0.546619 6.72115 0.546619 5.94567 1.02567 5.46662L5.69159 0.800695C6.17064 0.321643 6.94613 0.321643 7.42409 0.800695C7.90314 1.27866 7.90314 2.05414 7.42409 2.5332L4.79036 5.16699Z",
    fill: "#2D5171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.49f89526d20b13c1ba72fdd6822a8570.svg";
export { ForwardRef as ReactComponent };